// frontend/src/router/index.js

import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AboutView from '../views/AboutView.vue';
import BlogView from '../views/BlogView.vue';
import BlogPostView from '../views/BlogPostView.vue';
import NewsView from '../views/NewsView.vue';
import NewsItemView from '../views/NewsItemView.vue';
import LegalView from '../views/LegalView.vue';
import ContactView from '../views/ContactView.vue';
import DownloadsView from '../views/DownloadsView.vue';
// import CrudeOil from '@/views/markets/CrudeOil.vue'
import JapanPower from '@/views/markets/JapanPower.vue'
// import LNG from '@/views/markets/LNG.vue'
import JapanPowerWeek2025 from "@/views/campaigns/JapanPowerWeek2025.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogView
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: BlogPostView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/news/:slug',
    name: 'news-item',
    component: NewsItemView
  },
  {
    path: '/legal/:type',
    name: 'legal',
    component: LegalView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: DownloadsView
  },
  // {
  //   path: '/markets/crude-oil',
  //   name: 'crude-oil',
  //   component: CrudeOil
  // },
  {
    path: '/markets/japan-power',
    name: 'japan-power',
    component: JapanPower
  },
  // {
  //   path: '/markets/lng',
  //   name: 'lng',
  //   component: LNG
  // }
  {
    path: "/campaigns/japan-power-week-2025",
    name: "japan-power-week-2025",
    component: JapanPowerWeek2025,
  },
];

// Add language prefix routes
const supportedLanguages = ['en', 'ja'];
let localizedRoutes = [];

supportedLanguages.forEach(lang => {
  routes.forEach(route => {
    const localizedRoute = { ...route };
    localizedRoute.path = `/${lang}${route.path}`;
    localizedRoute.name = `${lang}-${route.name}`;
    localizedRoute.meta = { ...route.meta, locale: lang };
    localizedRoutes.push(localizedRoute);
  });
});

// Combine all routes
const allRoutes = [
  ...routes,          // Default routes (no language prefix)
  ...localizedRoutes  // Routes with language prefixes
];

// Add a catch-all route to redirect to home
allRoutes.push({
  path: '/:catchAll(.*)',
  redirect: '/'
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: allRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// Navigation guard to handle language detection
router.beforeEach((to, from, next) => {
  // Get current language from localStorage or default to English
  const currentLanguage = localStorage.getItem('locale') || 'en';

  // Set HTML lang attribute
  document.documentElement.setAttribute('lang', currentLanguage);

  // Set page title based on route meta
  if (to.meta.title) {
    document.title = to.meta.title + ' | CT Grid';
  } else {
    document.title = 'CT Grid';
  }

  // Check if route has language prefix
  const routeLocale = to.meta.locale;

  // If no language prefix but we have a preferred language (not default),
  // redirect to the same route with language prefix
  if (!routeLocale && currentLanguage !== 'en') {
    const redirectPath = `/${currentLanguage}${to.path}`;
    next(redirectPath);
    return;
  }

  next();
});

export default router;